import React from 'react';
import getBlogById from '../../../api/getBlogById';
import './BlogPage.css';
import BlogComments from '../../../components/blogComments/BlogComments';

export default class BlogPage extends React.Component {
  constructor(props){
    super(props);
    this.article=React.createRef();
  }

  async handleGetBlogArticle() {
    const blogInfo = await getBlogById(this.props.match.params.blogId);

    if(blogInfo.status === 200){
      this.article.current.innerHTML = blogInfo.blog.article
    }
  }

  componentDidMount() {
    this.handleGetBlogArticle()
  }

  render() {
    return (
      <React.Fragment>
        <section ref={this.article} className = "blog-content-section">
        </section>
        <BlogComments blogId={this.props.match.params.blogId}/>
      </React.Fragment>
    )
  }
}
